<template>
	<div class="user-forget-form">
		<h2>{{ 'email/title' | ftc }}</h2>
		<!-- блок с ошибкой -->
		<div v-show="isCodeError !== ''" class="alert alert-danger code-error" role="alert"><p v-withSafeTags="localeFtc(isCodeError)"></p></div>
		<!-- блок с успехом -->
		<div v-show="successMessage !== '' && successMessage !== false" class="alert alert-success code-success" role="alert">{{ successMessage | ftc }}</div>
		<!-- ссылка на главную -->
		<br>
		<div class="text-left code-link">{{ 'login/return_to_main_page1' | ftc }} <a href="/" :title="'login/return_to_main_page2' | ftc">{{ 'login/return_to_main_page2' | ftc }}</a></div>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'emailCheckForm',
	//=========================================================================
	// свойства компонента
	//=========================================================================
	data() {
		return {
			successMessage: false,
			isCodeError: '',
			isCode: null
		}
	},
	//=========================================================================
	// создание компонента
	//=========================================================================
	created() {
		// должен быть задан код - первое свойство объекта query
		let _keys = Object.keys(this.$route.query)
		// если кода нет - выводим ошибку и все
		if (!_keys.length)
		{
			this.isCodeError = 'email/check_notcode'
			return
		}

		// получаем код
		let _code = _keys[0]
		// проверка корректности кода
		if (_code === undefined || _code === null || String(_code).trim() === '')
		{
			this.isCodeError = 'email/check_notcode'
			return
		}

		// запоминаем код
		this.isCode = _code
	},
	//=========================================================================
	// компонент примонтирован в DOM
	//=========================================================================
	mounted() {
		// если задан код
		if (this.isCode)
		{
			// готовим url запроса
			let _url = this.APIServerUrl + '/email/check?' + this.isCode

			// запрос
			this.$http.get(_url).then(
				// успех
				data => {
					let _dt = data && data.data && typeof data.data === 'object' ? data.data : false
					if (_dt && typeof _dt === 'object' && 'status' in _dt && _dt['status'] === 'ok')
					{
						// покажем сообщение
						this.successMessage = _dt.content
						// на этом все
						return
					}

					// ошибка
					this.isCodeError = this.localeFtc('main/error_desc')
					let _msg = ''

					if (_dt && typeof _dt === 'object' && _dt['title']) _msg = _dt['title']
					if (_dt && typeof _dt === 'object' && _dt['content']) _msg = _dt['content']

					if (!_msg) this.isCodeError = this.isCodeError.replace(':', '.')
					else
					{
						_msg = '<b>' + _msg + '</b>'
						this.isCodeError += ' <br> ' + _msg
					}
				},
				// неудача
				error => {
					let _dt = error && error.data && typeof error.data === 'object' ? error.data : false
					this.isCodeError = this.localeFtc('main/error_desc')
					let _msg = ''

					if (_dt && typeof _dt === 'object' && _dt['title']) _msg = _dt['title']
					if (_dt && typeof _dt === 'object' && _dt['content']) _msg = _dt['content']

					if (!_msg) this.isCodeError = this.isCodeError.replace(':', '.')
					else
					{
						_msg = '<b>' + _msg + '</b>'
						this.isCodeError += ' <br> ' + _msg
					}
				}
			)
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// EmailCheck.vue?b5d3cf1c